import Swiper from 'swiper';

const breakpoint = window.matchMedia('(max-width: 767px)');
let catalogMain;
let catalogNews;
let catalogPromo;
// eslint-disable-next-line no-unused-vars
let horizontalServices;
// eslint-disable-next-line no-unused-vars
let catalogCategoryMain;
// eslint-disable-next-line no-unused-vars
let bannerCatalogMain;

const carouselProperties = {
  mainCatalogSlide: {
    slidesPerView: 4,
    slidesPerGroup: 1,
    spaceBetween: 10,
    watchOverflow: true,
    autoplay: {
      delay: 3000
    },
    navigation: {
      nextEl: '.main-catalog--buttons.swiper-button-next',
      prevEl: '.main-catalog--buttons.swiper-button-prev'
    },
    pagination: {
      el: '.main-catalog--bullets',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      1: {
        slidesPerView: 2,
        slidesPerGroup: 1
      },
      768: {
        slidesPerView: 4,
        slidesPerGroup: 1
      }
    }
  },
  bannerCatalog: {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 10,
    watchOverflow: true,
    autoplay: {
      delay: 3000
    },
    navigation: {
      nextEl: '.main-catalog--buttons.swiper-button-next',
      prevEl: '.main-catalog--buttons.swiper-button-prev'
    },
    pagination: {
      el: '.main-catalog--bullets',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      1: {
        slidesPerView: 1,
        slidesPerGroup: 1
      }
    }
  },
  mainCategorySlide: {
    slidesPerView: 4,
    slidesPerGroup: 1,
    spaceBetween: 0,
    watchOverflow: true,
    autoplay: {
      delay: 3000
    },
    navigation: {
      nextEl: '.main-catalog--buttons.swiper-button-next',
      prevEl: '.main-catalog--buttons.swiper-button-prev'
    },
    pagination: {
      el: '.main-catalog--bullets',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      1: {
        spaceBetween: 10,
        slidesPerView: 2,
        slidesPerGroup: 1
      },
      768: {
        spaceBetween: 10,
        slidesPerView: 4,
        slidesPerGroup: 1
      }
    }
  },
  horizontalServicesSlide: {
    slidesPerView: 4,
    slidesPerGroup: 1,
    spaceBetween: 10,
    watchOverflow: true,
    autoplay: {
      delay: 3000
    },
    navigation: {
      nextEl: '.horizontal--buttons.swiper-button-next',
      prevEl: '.horizontal--buttons.swiper-button-prev'
    },
    breakpoints: {
      1: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      500: {
        slidesPerView: 2,
        slidesPerGroup: 1
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 1
      },
      1024: {
        slidesPerView: 4,
        slidesPerGroup: 1
      }
    }
  },
  newsCatalogSlide: {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 20,
    watchOverflow: true,
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.swiper-pagination--catalog-news',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      550: {
        slidesPerView: 2,
        slidesPerGroup: 1
      }
    }
  },
  promoCatalogSlide: {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 20,
    watchOverflow: true,
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.swiper-pagination--catalog-promo',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      550: {
        slidesPerView: 2,
        slidesPerGroup: 1
      }
    }
  }
};

const catalogMainSlide = () => { catalogMain = new Swiper('.swiper-container--catalog-main', carouselProperties.mainCatalogSlide); };
const catalogNewsSlide = () => { catalogNews = new Swiper('.swiper-container--catalog-news', carouselProperties.newsCatalogSlide); };
const catalogPromoSlide = () => { catalogPromo = new Swiper('.swiper-container--catalog-promo', carouselProperties.promoCatalogSlide); };
const horizontalSlide = () => { horizontalServices = new Swiper('.swiper-container--horizontal', carouselProperties.horizontalServicesSlide); };
const catalogCategorySlide = () => { catalogCategoryMain = new Swiper('.swiper-container--product', carouselProperties.mainCategorySlide); };
const bannerCatalogSlide = () => { bannerCatalogMain = new Swiper('.swiper-container--feature-slider', carouselProperties.bannerCatalog); };


const breakpointChecker = () => {
  catalogMainSlide();
  horizontalSlide();
  bannerCatalogSlide();
  if (breakpoint.matches === false) {
    if (catalogNews !== undefined) {
      catalogNews.destroy(true, true);
      $('.swiper-pagination--catalog-news').html('');
    }
    if (catalogPromo !== undefined) {
      catalogPromo.destroy(true, true);
      $('.swiper-pagination--catalog-promo').html('');
    }
  } if (breakpoint.matches === true) {
    catalogNewsSlide();
    catalogPromoSlide();
    catalogCategorySlide();

    if (catalogMain === undefined || catalogMain.destroyed === true) {
      if ($('.swiper-container--catalog-main .swiper-wrapper').children('div').length > 2) {
        catalogMainSlide();
        $('.swiper-pagination--news-books').css('display', 'block');
      }
    }
  }
};

breakpoint.addListener(breakpointChecker);

export default breakpointChecker;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/books/booksSliders.js